<template>
  <div class="copyright">
    <div class="con_data copy">
      <div class="left">
        <div>
          <div><img :src="icon" style="width: 150px;height: 150px"></div>
        </div>
        <div class="con">
          <h2>河北八友台智能科技有限公司</h2>
          <div>联系地址：石家庄市新石北路367号 金石工业园创新大厦605室</div>
          <div>联系电话：19567908984</div>
          <div>联系邮箱：byt19567908984@163.com</div>
          <div><a href="http://www.hbbytzn.com/#/index" target="_blank">冀ICP备17032123号</a></div>
        </div>
      </div>
      <div class="right">
        <p>Focus on intelligent manufacturing system development and services</p>
        <h2>专注于智能制造系统研发及服务</h2>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "copyright",
  data() {
    return {
      icon:require('../assets/12.png'),
    }
  }
}
</script>

<style scoped>
  .copyright{
    width: 100%;height: 300px;
    background-color: rgb(89, 87, 87);
    clear: both;
  }
  .copy{
    box-sizing: border-box;
    padding: 70px 0;
    display: flex;
    justify-content: space-between;
    color: #fff;
  }
  .left{
    display: flex;
    justify-content: left;
  }
  .left .con{
    padding-left: 30px;
    box-sizing: border-box;
  }
  .con a{
    text-decoration: none;
    color: #fff;
  }
</style>